import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class AuthValidators {
  public static password(control: FormControl): ValidationErrors {
    return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$&()*\\-`._+,])[A-Za-z\\d!@#$&*()\\-`._+,]{8,}').test(control.value) ? null : { password: true };
  }

  public static equalsField(field: string): ValidatorFn {

    const result =  function (control: AbstractControl): Record<string, boolean> | null {
      const comparisonControl = control.root.get(field);
      if (comparisonControl) {
        if (comparisonControl.value !== control.value) {
          return { equalsField: true };
        }
      }

      return null;
    };

    return result;
  }
}
